import { LinearProgress } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Suspense } from 'react'
import { makeStylesFast } from 'siteline-common-web'
import { NotFound } from '../common/components/404'
import NavBar, { NavBarProvider, useNavBar } from '../common/components/NavBar'
import TopBar from '../common/components/TopBar'

const useStyles = makeStylesFast(() => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
  },
  content: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
  },
}))

// All routes under `_a` require an authenticated admin and render inside the nav chrome.
export const Route = createFileRoute('/_a')({
  beforeLoad: ({ context, location }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: '/signin',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: Component,
  notFoundComponent: NotFound,
})

/** Chrome shared by every authenticated page: top bar, nav drawer and page container */
function AuthenticatedLayout() {
  const classes = useStyles()
  const { isOpen, setIsOpen } = useNavBar()

  return (
    <>
      <TopBar onOpenMenu={!isOpen ? () => setIsOpen(true) : undefined} />
      <NavBar onClose={isOpen ? () => setIsOpen(false) : undefined} />
      <div className={classes.container}>
        <div className={classes.content} style={{ paddingLeft: isOpen ? 256 : 16 }}>
          <Suspense fallback={<LinearProgress />}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Outlet />
            </LocalizationProvider>
          </Suspense>
        </div>
      </div>
    </>
  )
}

function Component() {
  return (
    <NavBarProvider>
      <AuthenticatedLayout />
    </NavBarProvider>
  )
}
